export default "__VITE_ASSET__Bb$fnvn1__"